import type { EngagementType, WorkflowConfig } from "@talenthop/shared";
import { inr } from "../../lib/format.js";

/** The engagement type of a requisition, read from the top-level column or the config fallback. */
export function engagementOf(
  source: { engagementType?: EngagementType | null; config?: { engagementType?: EngagementType } },
): EngagementType {
  return source.engagementType ?? source.config?.engagementType ?? "fte";
}

/** Human label for a requisition's engagement — "FTE" or "Staff-aug · N months · ₹rate/mo". */
export function engagementLabel(
  engagementType: EngagementType,
  config?: Pick<WorkflowConfig, "projectDurationMonths" | "minRateInr">,
): string {
  if (engagementType !== "staff_aug") return "FTE";
  const parts: string[] = ["Staff-aug"];
  if (config?.projectDurationMonths) parts.push(`${config.projectDurationMonths} months`);
  if (config?.minRateInr) parts.push(`${inr(config.minRateInr)}/mo`);
  return parts.join(" · ");
}

/** CSS pill class for the engagement tag — staff-aug gets the violet accent, FTE the neutral one. */
export function engagementPillClass(engagementType: EngagementType): string {
  return engagementType === "staff_aug" ? "pill pv" : "pill n";
}
